import { ArrowBack } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { getBookingBackTarget } from '../../utils/bookingNavigation';

interface BackdoorProps {
  title: string;
}
export const Backdoor = ({ title }: BackdoorProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    const backTarget = getBookingBackTarget(location.state);
    if (backTarget) {
      navigate(backTarget.path, { replace: backTarget.replace });
      return;
    }
    navigate(-1);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
      <IconButton
        onClick={handleBack}
        sx={{ mr: 1, color: '#FFFFFF', p: 0.5 }}
        size="small"
      >
        <ArrowBack sx={{ color: 'white', fontSize: 20 }} />
      </IconButton>
      <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#FFFFFF', lineHeight: 1.2 }}>
        {title}
      </Typography>
    </Box>
  );
};
